import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../../lib/enums"
import { MessagePublishType } from "../serviceCenterMessagesTypes"

type SelectPublishTypeFilterProps = Readonly<{
    value: MessagePublishType
    onChange: (val: MessagePublishType) => void
}>

export function SelectPublishTypeFilter({ value, onChange }: SelectPublishTypeFilterProps) {
    return (
        <FormControl size="small" sx={{ minWidth: "10rem" }}>
            <LocalizedStrict id="messages-table-publish-type-filter-label">
                <InputLabel>Publish type</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="messages-table-publish-type-filter-label-label" attrs={{ label: true }}>
                <Select
                    value={value}
                    label="Publish type"
                    onChange={(e: SelectChangeEvent) => onChange(e.target.value as MessagePublishType)}
                >
                    {[...iterateStringEnum(MessagePublishType)].map((val) => (
                        <MenuItem key={val} value={val}>
                            <LocalizedEnum base="messages-table-publish-type-filter-item" enumValue={val}>
                                <span>{val}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
